@if (isLoading) {
<mat-progress-bar mode="indeterminate" value="50" color="primary"></mat-progress-bar>
}
<div [ngClass]="[bgColor, paddingX]" class="flex flex-col h-full">
  <ng-content select="[header]"></ng-content>
  <div class="grid" [ngClass]="data?.length === 0 ? 'flex flex-1' : height">
    @if (hasError) {
    <div class="flex items-center justify-center h-auto text-action-bg-error gap-050-em">
      <i class="icon_marina_ui_CrossContainedOutlined text-feedback-fg-error text-[1rem]"></i>
      Something went wrong. Please try again later.
    </div>
    } @else if (!hasError && !isLoading && data?.length === 0) {
    <div class="flex items-center justify-center h-full">
      <remote-update-domain-empty-state
        [title]="emptyTitle"
        [description]="emptyDescription"></remote-update-domain-empty-state>
    </div>
    } @else {
    <ng-content select="[content]"></ng-content>
    }
    <router-outlet></router-outlet>
  </div>
</div>
